import { useState } from 'react'

import { Box, BoxList } from '@factorialco/deprecated-design-system'
import { ContractTemplatesFragment } from 'generated/resources/graphql'

import SelectField from 'modules/core/components/SelectField'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import ContractField from '../ContractField'
import { ContractFieldsProps } from '../types'
import { countryLabel, getTaxonomyName } from './taxonomyTranslator'

type Props = {
  companyTemplatesTaxonomies: ContractTemplatesFragment[]
  hasDevCompensations: boolean
}

type Language = 'spanish' | 'french' | 'german' | 'portuguese'

const countryPrefixes: Record<string, Language> = {
  es: 'spanish',
  fr: 'french',
  de: 'german',
  pt: 'portuguese',
}

const Taxonomies = ({ companyTemplatesTaxonomies, hasDevCompensations }: Props) => {
  const defaultTemplate = companyTemplatesTaxonomies[0]?.id
  const showSelector = companyTemplatesTaxonomies.length > 1
  const [selectedTemplate, setSelectedTemplate] = useState<number>(defaultTemplate || 0)
  const contractTemplatesOptions = useUnsafeMemo(() => {
    return companyTemplatesTaxonomies.map((template) => ({
      label: countryLabel(template.contractVersionType || ''),
      value: template.id,
    }))
  }, [companyTemplatesTaxonomies])

  const handleTemplateChange = (value: string) => {
    setSelectedTemplate(+value)
  }

  const selectedTemplateValues = companyTemplatesTaxonomies.find(
    (template) => template.id === selectedTemplate
  )

  const prefix = countryPrefixes[selectedTemplateValues?.contractVersionType || ''] || ''

  const selectedTemplateTaxonomies = () => {
    if (!selectedTemplateValues || !selectedTemplateValues.contractVersionType) return {}

    const filteredResults: { [key: string]: Array<ContractFieldsProps> } = {}

    Object.entries(selectedTemplateValues).forEach(([key, value]) => {
      if (key.startsWith(prefix) && Array.isArray(value)) {
        filteredResults[key] = value
      }
    })

    return filteredResults
  }

  return (
    <Box flexDirection="column" gap="s16">
      <Box maxWidth="fit-content">
        {showSelector && (
          <SelectField
            options={contractTemplatesOptions}
            value={selectedTemplate?.toString()}
            onChange={handleTemplateChange}
          />
        )}
      </Box>
      <BoxList>
        {Object.keys(selectedTemplateTaxonomies())
          .filter((key) => (hasDevCompensations ? key != 'compensations' : true))
          .map((key, index) => (
            <ContractField
              key={index}
              name={getTaxonomyName(key.replace(prefix, ''))}
              values={selectedTemplateTaxonomies()[key]}
              originalKey={key}
              contractsTemplateId={selectedTemplate}
            />
          ))}
      </BoxList>
    </Box>
  )
}

export default Taxonomies
